import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

const useLoadProductsWithAttributes = (productIds: (string | null | undefined)[]): void => {
    const validIds = useMemo(
        () => productIds.filter((id): id is string => !!id),
        [productIds.filter(Boolean).join(",")],
    );

    const idsToLoad = useSelector((state: ApplicationState) =>
        validIds.filter(id => {
            const product = getProductState(state, id).value;
            return !product || !product.attributeTypes;
        }),
    );

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (idsToLoad.length === 0) {
            return;
        }
        dispatch(
            loadProducts({
                productIds: idsToLoad,
                expand: ["attributes"],
                includeAttributes: ["includeOnProduct"],
            }),
        );
    }, [idsToLoad.join(",")]);
};

export default useLoadProductsWithAttributes;
